/**
 * PATH: packages/bills/src/components/merge-bill.ts
 * FILE_ID: BILLS-PKG-UTIL-MERGE-004
 * PURPOSE: Overlay the local edit draft on top of the server bill so the
 *          form always renders the operator's in-progress values.
 *
 * WHY: Edits stay local until "Save" (no per-keystroke PATCH); every field
 *      read goes through this merged view so drafts and persisted values
 *      never diverge on screen.
 *
 * Extracted verbatim from BillDataPanel.tsx (P4-1 split) — no behaviour change.
 */

import type { BillDetail, BillEditablePatch } from '../types';

export function mergeBill(
  bill: BillDetail | null,
  draft: BillEditablePatch,
): Partial<BillDetail> {
  if (!bill) return draft;
  return { ...bill, ...draft };
}
